import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarAddressFilterComponent } from './calendar-address-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from '@shared-pipes/pipes.module';
import { DirectivesModule } from '@shared-directives/directives.module';
import { TranslationModule } from '@app/app-translation.module';
import { FormNumberModule } from '@beego/ngx-form-components';
import { FormSearchAddressModule } from '@internal/gui/structural-components/form-components/form-search-address-component/form-search-address.component.module';
import { NgxSliderModule } from 'ngx-slider-v2';

@NgModule({
	declarations: [CalendarAddressFilterComponent],
	exports: [CalendarAddressFilterComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		IonicModule,
		TranslationModule,
		PipesModule,
		DirectivesModule,
		FormSearchAddressModule,
		FormNumberModule,
		NgxSliderModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CalendarAddressFilterComponentModule {}
